import { useEffect, useState } from 'react';
import axios from 'axios';

const useApi = ({ method }) => {
  let controller;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async data => {
    let formData;
    setLoading(true);

    controller = new AbortController();
    const timeoutSignal = AbortSignal.timeout(5000);

    if (data) {
      formData = new FormData();
      Object.entries(data).forEach(([key, value]) => formData.append(key, value));
    }

    try {
      const result = await axios({
        method,
        baseURL: '/',
        url: '/support.php',
        data: formData,
        signal: AbortSignal.any([controller.signal, timeoutSignal]),
        timeout: 5000,
      });
      setLoading(false);
      return result.data;
    } catch ({ message }) {
      setLoading(false);
      setError(error);
      console.error(`Error on ${method}: `, message);
    }
  };

  useEffect(() => {
    return () => controller && controller.abort();
  }, []);

  return { fetchData, loading, error };
};

export default useApi;
